// extracted by mini-css-extract-plugin
export var countrySelector = "global-offices-module--countrySelector--faa96";
export var dots = "global-offices-module--dots--b8319";
export var gallery = "global-offices-module--gallery--e2d12";
export var galleryWrapper = "global-offices-module--galleryWrapper--d259b";
export var mapContainer = "global-offices-module--mapContainer--a1b37";
export var mapFrame = "global-offices-module--mapFrame--551b2";
export var nextArrowButton = "global-offices-module--nextArrowButton--c02b4";
export var officeCard = "global-offices-module--officeCard--72f6c";
export var prevArrowButton = "global-offices-module--prevArrowButton--f269e";
export var siteUrl = "global-offices-module--siteUrl--57439";
export var wrapper = "global-offices-module--wrapper--37a2e";